import consola from "consola"

/**
 * @param resp - Axios Response object.
 */
export default function (resp) {
  if (resp) {
    const method = resp.config.method
    const url = resp.config.url
    const baseURL = resp.config.baseURL
    const data = resp.data
    const resStatus = resp.status
    const txtStatus = resp.statusText

    var log = "[NETWORK]: " + method + " on " + `${baseURL} - ${url}`

    if (resStatus && txtStatus)
      log += " succeeded with " + resStatus + " " + txtStatus
    consola.success(log)
    if (typeof data !== "undefined" && process.client) {
      if (typeof data === "string") consola.success(data.substr(0, 150))
      else consola.success(data)
    }
    if (resp.headers["set-cookie"]?.length) {
      const cookies = this.$cookies.getAll({ parseJSON: true })
      const settedKeys = new Set()
      const rejectedKeys = ["expires", "Path", "SameSite"]

      resp.headers["set-cookie"].forEach((cookieStr) => {
        const cookieObj = this.$cookies.nodeCookie.parse(cookieStr)

        Object.keys(cookieObj ?? {}).forEach((key) => {
          if (!rejectedKeys.includes(key)) {
            settedKeys.add(key)
            this.$cookies.set(key, cookieObj[key], {
              path: cookieObj["Path"] ?? undefined,
              expires: cookieObj["expires"]
                ? new Date(cookieObj["expires"])
                : undefined,
              sameSite: cookieObj["SameSite"] ?? undefined,
              httpOnly: cookieObj["httpOnly"] ?? false,
            })
          }
        })
      })
      this.$cookies.setAll(
        Object.keys(cookies).reduce((acc, key) => {
          if (![...settedKeys].includes(key)) acc[key] = cookies[key]
          return acc
        }, [])
      )
    }
  }
  return resp
}
